'use client'

import * as React from 'react'
import { useEffect } from 'react'
import type { BlogLayoutProps } from './types'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import routes from 'web/src/lib/routes'
import classNames from 'classnames'
import useContactSupportTracking from 'web/src/lib/hooks/useContactSupportTracking'
import { PolicyLink } from '../../components/Footer/types'
import { useStore } from 'web/src/lib/context/store-context'
import { useAccount } from 'web/src/lib/context/account-context'
import Carousel from '../../components/Carousel'
import Cart from '../../components/Cart'
import Navigation from '../../components/Navigation'
import QuantityError from '../../components/QuantityError'
import BlogDetailHero from '../../components/Blog/BlogDetailHero'
import { constants } from '../../constants'
import BlogSlider from '../../components/Blog/BlogSlider'
import BlogSidebar from '../../components/Blog/BlogSidebar'

const BlogLayout = ({ sidebarItems, children, heroProps, headerProps, blogItems }: BlogLayoutProps) => {
    useContactSupportTracking()
    const socials = constants['socials']
    const { customer } = useAccount()
    const { menuOpen, setMenuOpen } = useStore()

    useEffect(() => {
        setMenuOpen(false)
        window.scroll(0, 0)
    }, [])

    return (
        <>
            <QuantityError />
            <div className={`bg-white`}>
                <Header
                    accountHeader={headerProps?.accountHeader}
                    useGradient={headerProps?.useGradient}
                    overflow={headerProps?.overflow}
                    dark={headerProps?.dark}
                    checkoutProgress={headerProps?.checkoutProgress}
                    color={headerProps?.color}
                    disableAccountIcon={headerProps?.disableAccountIcon}
                    backButton={headerProps?.backButton}
                    darkOnMobile={headerProps?.darkOnMobile}
                />
                <Navigation
                    navigationOpen={menuOpen}
                    onClose={() => setMenuOpen(!menuOpen)}
                    menuItems={[
                        {
                            label: 'Gerechten',
                            slug: '/gerechten',
                        },
                        {
                            label: 'Blog',
                            slug: '/blog',
                        },
                        {
                            label: 'FAQ',
                            slug: '/veelgestelde-vragen',
                        },
                    ]}
                    account={{
                        label: customer ? 'Mijn account' : 'Inloggen',
                        slug: customer ? routes.account : routes.login,
                    }}
                    contact={{
                        label: 'Neem contact op',
                        slug: 'mailto:info@goodchef.nl',
                    }}
                />
                <div style={{ contain: 'paint' }}>
                    <BlogDetailHero content={heroProps?.content} image={heroProps?.image} tags={heroProps?.tags} />
                    <div className="container flex">
                        <article className={classNames(`w-full mt-10 lg:w-6/12 relative z-[100] flex flex-col px-0`)}>
                            {children}
                        </article>
                        <div className="z-[100] w-6/12">
                            <BlogSidebar items={sidebarItems} />
                        </div>
                    </div>
                    {blogItems && <BlogSlider blogItems={blogItems} />}
                </div>
                <Carousel is404={false} />
                <Footer
                    socials={socials}
                    links={[
                        {
                            label: 'Onze maaltijden',
                            slug: routes.products,
                        },
                        {
                            label: 'Veelgestelde vragen',
                            slug: routes.faq,
                        },
                        {
                            label: 'Contact',
                            slug: 'mailto:info@goodchef.nl',
                        },
                    ]}
                    policies={
                        [
                            {
                                label: 'Voorwaarden',
                                slug: routes.termsOfUse,
                            },
                            {
                                label: 'Privacy Policy',
                                slug: routes.privacyPolicy,
                            },
                            {
                                label: 'Cookie instellingen',
                                slug: '#cookie-settings',
                            },
                        ] as PolicyLink[]
                    }
                />
            </div>
            <Cart mobile />
        </>
    )
}

export default BlogLayout
